import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.CancelRequestPopup', {
    cancelButtonText: 'Cancel request',
    cancelButtonTitle: 'Cancel the request',
    descriptionText: 'Please provide a comment as to why you are cancelling the request',
    popupTitle: `Cancel "{requestName}"`,
});
